import type { ComputedRef } from 'vue';
import type { MonospaceSpace } from '#layers/data-model/public';
import { computed } from 'vue';
import { useStore } from '#imports';
import { compareSortable } from '#layers/base/public';

export function useSpaces(): ComputedRef<MonospaceSpace[]> {
	const store = useStore();

	const { data: spaces } = store.MonospaceSpace.query((q) => q.many());

	return computed(() => spaces.value.toSorted(compareSortable));
}
